module.exports = __webpack_public_path__ + "./kai_fee96a444b8d2a797d152d6bc3734b35.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/kai.png
// module id = 423
// module chunks = 0